const LogoComp = () => {
    return ( <div className="logoComp">
        {/* <h2>Hello</h2> */}
        <img
        style={{backgroundColor:"red"}}
        src="../assets/letsNote.png" alt=""/>
    </div> );
}
 
export default LogoComp;